import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";

import { ToastService } from "@shared/lib/services";
import {
  IAddSocialMediaBulkRequest,
  IAddSocialMediaBulkResponseRow,
} from "@shared/lib/types/influencer";
import { BriefService } from "../services/brief.service";

export function useAddSocialMediaBulk(
  handleSuccess: (data: IAddSocialMediaBulkResponseRow[]) => void
) {
  const {
    mutate: addSocialMediaBulk,
    isLoading: isAddingSocialMediaBulk,
    isSuccess: isAddedSocialMediaBulk,
  } = useMutation<
    IAddSocialMediaBulkRequest,
    BackednResponse<IAddSocialMediaBulkResponseRow[]>
  >({
    mutationFn: async (request) => {
      return await BriefService.addSocialMediaBulk(request).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data) => {
      handleSuccess(data.data);
    },
  });

  return {
    addSocialMediaBulk,
    isAddingSocialMediaBulk,
    isAddedSocialMediaBulk,
  };
}
